import axios from 'axios'
import router from '../router'
import store from '../store'
import { Message } from 'element-ui'
import {base} from './index'
import { EncryptData } from '../assets/js/common/encrypt'
// import 'element-ui/lib/theme-chalk/index.css'
let cancel, promiseArr = {};
const storage = window.localStorage;
const toLogin = () =>{
    router.replace({
        path: '/login',
        query: {
            redirect: router.currentRoute.fullPath
        }
    })
};

const instance = axios.create({
    baseURL: `${base.offline}`,
    timeout: 1000 * 15,
    headers: {
        // 'Content-Type': "application/json:charset=utf-8",
        // 'Authorization': 'EPC ' + store.state.acs_Token,
    }
});

const logout = function(){
  router.push({ name: 'login' });
  localStorage.clear();
};

const errorHandle = (status, content, errorCode) => {
    // 状态码判断
    if(status && content){//后台返回的状态码
        // let time_count = 3,interval_time;
        if(errorCode === 7005){//token非新鲜，某些敏感操作不能执行
          Message.error({
            message: errorCode+'----'+content
          });
          setTimeout(function(){
            logout();
          }, 500)
        }
        else{
          switch (status) {
            case 400:
              Message.error({
                message: content+'----'+errorCode });
              break;
            case 401:
              // token过期的处理
              logout()
              // refreshing_token();
              // if(localStorage.getItem('refresh_token')){
              //   Message.info({
              //     message: 'token认证过期,即将刷新...',
              //     duration: 2000});
              // }
              break;
            //request is expired(时间戳大于相差30s)/missing paramor0(发送参数有问题：缺参或位置错误)/missing content_type
            case 403:
              Message.error({
                message: '拒绝访问 --'+content+'----'+errorCode });
              break;
            case 404:
              Message.error({
                message: '未找到请求资源 --'+content+'----'+errorCode });
              break;
            default:
              Message.error({
                message: '未知错误 --'+content+'----'+errorCode });
              break;
          }
        }
    }
}

// 设置post请求头
// instance.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded';

//请求拦截器
instance.interceptors.request.use(
    config => {
        //发起请求时，取消当前正在进行的相同操作
        if(promiseArr[config.url]){
            promiseArr[config.url]('操作取消');
            promiseArr[config.url] = cancel;
        }
        else{
            promiseArr[config.url] = cancel;
        }
         let acs_token = store.state.acs_Token ? store.state.acs_Token : storage.getItem('access_token');
         config.headers['Authorization'] = 'EPC '+acs_token;//请求拦截器里加上token
        return config;
    },
    error => {
        return Promise.reject(error)
    }
);

instance.defaults.retry = 1;//重试次数
instance.defaults.retryDelay =  1500;//重试延迟
// axios.defaults.shouldRetry = (error) => true; //重试条件，默认只要是错误都需要重试
// 响应拦截器
let resInterceptor =  instance.interceptors.response.use(
    // 请求成功
    res => {
        // console.log('s响应拦截器： ',res.data.msg.zh, res.data);
        if(res.status===200){
            if(res.data.flag===0){
                Message.error({
                    message: res.data.code+'----'+res.data.msg.zh,
                });
            }
            Promise.resolve(res);
        }
        else{
            Promise.reject(res);
        }
        return res
    },
    // 请求失败
    error => {
        let config = error.config;
        // console.log('e响应拦截器： ', error, config,error.response);
        const response = error.response;
        if (response && response.data.flag !==1 && response.data.code !== 7003) {
            // 请求已发出，但是不在2xx的范围
            errorHandle(response.status, response.data.msg.zh, response.data.code);
            if(response.data.code === 7001){
              // 判断是否配置了重试
              if(!config || !config.retry){
                return Promise.reject(error);
              }
              config.__retryCount = config.__retryCount || 0;
              // 判断是否超过了重试次数
              if(config.__retryCount >= config.retry) {//retryCount默认设置为0,retry默认为1，所以只重试一次。
                return Promise.reject(error);
              }
              //重试次数自增
              config.__retryCount += 1;
              let retryReq = new Promise(function(resolve) {
                setTimeout(function(){
                  resolve();
                }, 2800)//这里设置3秒后重置
              });

              return retryReq.then(function() {
                return instance(config)
              })
          }
            // return Promise.reject(response);
        } else {
          if(response.data && response.data.code === 7003)
            router.push({ name: 'login' });
            store.commit('changeNetwork', false);
        }
        return Promise.reject(error);
    }
);


//请求新的token
let cancelfun;
function refreshing_token(){
  let refresh_success = 0;
  if(typeof cancelfun === 'function')
  cancelfun();
    axios.get(base.offline+'/refresh',{
        headers: {
            'Authorization': 'EPC '+localStorage.getItem('refresh_token'),
            'Content-Type': 'application/json;charset=UTF-8'//不加会403，没有用户许可
        },
        params: EncryptData({}),
        cancelToken: new axios.CancelToken(function executor(c) {
          cancelfun = c;
        })
      })
        .then( res => {
          if(res.data.flag === 1){
            storage.setItem('access_token', res.data.data.access_token);
            refresh_success = 1;
          }
          else{
            Message.error(res.data.msg.zh+'-----'+res.data.code);
            refresh_success = 0;
          }
        })
        .catch( error => {
          refresh_success = 0;
          if(axios.isCancel(error)) {
              // console.log('Request canceled',error);//if the request be canceled,return a 'mes' that be canceled here,
          }else{
            // Message.error(error.response.data.code+'--'+error.response.data.msg.zh+' 请重新登录');
            setTimeout(function () {
              logout();
            },500)
          }
        });
    return refresh_success;
}

export default instance;//不能加大括号
export {
    refreshing_token,
    logout,
}
